import { Button, ButtonProps } from '@practium/ui';
import styles from './PolicyActionButtons.module.css';

export const DeleteButton = ({ children, className, ...props }: ButtonProps) => {
	return (
		<Button variant="danger" className={`${styles.deleteButton} ${className || ''}`} {...props}>
			{children}
		</Button>
	);
};

export const VisualizeButton = ({ children, className, ...props }: ButtonProps) => {
	return (
		<Button variant="outline" className={`${styles.visualizeButton} ${className || ''}`} {...props}>
			{children}
		</Button>
	);
};

export const SaveButton = ({ children, className, ...props }: ButtonProps) => {
	return (
		<Button variant="primary" className={`${styles.saveButton} ${className || ''}`} {...props}>
			{children}
		</Button>
	);
};
